module.exports = __webpack_public_path__ + "assets/img/chatyuan.75851943.svg";